import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    row: {
        pointerEvents: 'none',
        position: 'relative',
        border: 'none',
    },
});
